const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/faq/reducers/faq.reducer.js